import { httpService } from '@/services/HttpService';

class LocaleService {
  setLocale(locale: string): Promise<any> {
    return httpService.put(`account_setting/locale`, { locale }).then(() => {
      localStorage.setItem('locale', locale);
    });
  }

  getLocale(): string {
    let language = localStorage.getItem('locale');

    if (language) {
      return language;
    }

    language = window.navigator.language;

    if ((language || '').indexOf('pl') !== -1) {
      return 'pl';
    }

    return 'en';
  }
}

export const localeService = new LocaleService();
